import { onError } from "@apollo/client/link/error";

const ORIGIN_MISMATCH_CODE = "ORIGIN_MISMATCH";

const originGuardLink = onError(({ networkError }) => {
  if (!networkError) return;
  const statusCode = networkError.statusCode;
  const result = networkError.result;
  if (
    statusCode !== 403 ||
    !result ||
    result.code !== ORIGIN_MISMATCH_CODE ||
    !result.redirectUrl
  ) {
    return;
  }
  try {
    localStorage.clear();
  } catch (error) {
    void error;
  }
  window.location.replace(result.redirectUrl);
});

export default originGuardLink;
